import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 bg-stone-900 text-stone-50" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-147">
        <div className="text-center mb-16" data-id="element-148">
          <h2 className="text-3xl md:text-4xl font-serif font-bold mb-6" data-id="element-149">
            El problema no es que seas una persona desordenada.
          </h2>
          <p className="text-xl text-stone-300 max-w-3xl mx-auto leading-relaxed" data-id="element-150">
            El problema es que intentas limpiar tu casa como si fuera un sábado
            de primavera, cuando lo que tienes es una emergencia de martes por
            la tarde.
          </p>
        </div>

        <div className="bg-stone-800/50 rounded-3xl p-8 md:p-12 border border-stone-700 mb-16" data-id="element-151">
          <p className="text-lg text-stone-300 mb-6 leading-relaxed" data-id="element-152">
            Intentas recoger un calcetín aquí y lavar una taza allá, pero el
            reloj sigue corriendo y la casa se sigue viendo igual. Estás
            agotado, sudado y el caos visual sigue ahí.
          </p>
          <p className="text-lg text-stone-300 font-medium" data-id="element-153">
            Has estado luchando contra el desorden de la manera equivocada
            porque nadie te enseñó la diferencia entre "limpieza profunda" y
            "gestión de escenario".
          </p>
        </div>

        <div className="space-y-8" data-id="element-154">
          <h3 className="text-2xl font-serif font-bold text-center mb-10 text-orange-400" data-id="element-155">
            Por qué lo que has intentado NO funciona:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-156">
            {['Intentaste limpiar por categorías (ropa, papeles, basura) y perdiste 20 minutos solo en la primera montaña.', 'Intentaste organizar cajones internos mientras la sala principal seguía siendo un desastre visual.', 'Usaste ambientadores dulces que solo camuflaron el olor a encierro en lugar de neutralizarlo.', 'Te paralizaste ante la magnitud del desorden y terminaste sin hacer nada efectivo.'].map((item, index) => <div key={index} className="flex items-start space-x-4 bg-stone-800 rounded-2xl p-6" data-id="element-157">
                <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-158" />
                <p className="text-stone-300" data-id="element-159">{item}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}